import { render } from "./FORUM_UPDATE_AVATAR.vue?vue&type=template&id=0960c336"
import script from "./FORUM_UPDATE_AVATAR.vue?vue&type=script&lang=js"
export * from "./FORUM_UPDATE_AVATAR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__